// pages/mim-balance.js
import React, { useState } from "react";
import moment from "moment";
import axios from "axios";
import "./Styles/table.css";

const MimBalance = () => {
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [startDateTime, setStartDateTime] = useState("");
  const [endDateTime, setEndDateTime] = useState("");
  const [searchData, setSearchData] = useState("");
  const [originalData, setOriginalData] = useState([]);

  const handleClick = async () => {
    const formattedStart = startDateTime
      ? moment(startDateTime).format("MMM DD YYYY HH:mm:ss [GMT]ZZ")
      : "";
    const formattedEnd = endDateTime
      ? moment(endDateTime).format("MMM DD YYYY HH:mm:ss [GMT]ZZ")
      : "";

    const payload = {
      key: "getMIMBalanceTxsWithDateRange",
      data: {
        startDate: formattedStart,
        endDate: formattedEnd,
      },
    };

    setIsLoading(true);

    try {
      const response = await axios.post(
        "https://app.myimpactmeter.com/api/v2/prod/admin/adminPortal/getItemByKey",
        { ...payload }
      );
      setIsLoading(false);
      setTableData(response.data.data);
      setOriginalData(response.data.data);
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  const handleSearchData = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchData(e.target.value);

    if (searchValue === "") {
      setTableData(originalData);
    } else {
      const filteredData = originalData.filter(
        (item:any) =>
          (item.ImpactorName &&
            item.ImpactorName.toLowerCase().includes(searchValue)) ||
          (item.impactorEmail &&
            item.impactorEmail.toLowerCase().includes(searchValue))
      );
      setTableData(filteredData);
    }
  };

  const convertToCSV = (dataArray) => {
    const header = Object.keys(dataArray[0]).join(",");
    const body = dataArray.map((item) => Object.values(item).join(",")).join("\n");
    return `${header}\n${body}`;
  };

  const handleDownload = () => {
    const csvContent = convertToCSV(tableData);
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "table_data.csv");
    document.body.appendChild(link);
    link.click();
  };


    const dummyData = [
      { id: 1, name: "John Doe", age: 30, city: "New York" },
      { id: 2, name: "Jane Smith", age: 25, city: "Los Angeles" },
      { id: 3, name: "Sam Brown", age: 35, city: "Chicago" },
    ];
  
  return (
    <div style={{ padding: "20px", width: "100%", fontFamily: "Arial, sans-serif" }}>
      <h2 style={{ marginBottom: "20px", color:'white' ,fontSize: "24px" }}>Mim Balance Transactions</h2>
      
      
      <div style={{ marginBottom: "20px" }}>
        <input
          type="text"
          placeholder="Search by Impactor Name"
          value={searchData}
          onChange={handleSearchData}
          style={{ padding: "10px", width: "60%", marginBottom: "10px" }}
        />
      </div>
      
      <div style={{ display: "flex",}}>
      <div style={{ display: "flex", gap: "0px", marginBottom: "20px" }}>
        <div>
          <label>Start Date:</label>
          <input
            type="datetime-local"
            value={startDateTime}
            onChange={(e) => setStartDateTime(e.target.value)}
            style={{ display: "block", padding: "10px", marginTop: "5px" }}
          />
        </div>
        <div>
          <label>End Date:</label>
          <input
            type="datetime-local"
            value={endDateTime}
            onChange={(e) => setEndDateTime(e.target.value)}
            style={{ display: "block", padding: "10px", marginTop: "5px" }}
          />
        </div>
      </div >

      <div style={{ marginTop: "16px" }}>
        <button
          onClick={handleClick}
          style={{ padding: "10px 30px", marginRight: "10px", cursor: "pointer" }}
        >
          Search
        </button>
        <button
          onClick={handleDownload}
          style={{ padding: "10px 20px", cursor: "pointer" }}
        >
          Download CSV
        </button>
      </div>




   
      </div>

      
      <div className="table">


      {isLoading ? (
        <div           style={{ padding: "10px 20px", fontSize:'40px', width:'100%' ,height:'500px'}}
> <p>Loading...</p>

        </div>
        )
        :
        (
      <table>
        <thead>
        <tr>
              <th style={{ border: "1px solid #ccc", padding: "1px" }}>No #</th>
              <th style={{ border: "1px solid #ccc", padding: "10px" }}> Instrument No</th>
              <th style={{ border: "1px solid #ccc", padding: "10px" }}>Impactor Name</th>
              <th style={{ border: "1px solid #ccc", padding: "10px" }}>Impactor Email</th>
              <th style={{ border: "1px solid #ccc", padding: "10px" }}>Join Date</th>
              <th style={{ border: "1px solid #ccc", padding: "10px" }}>Contact</th>
              <th style={{ border: "1px solid #ccc", padding: "10px" }}>Country</th>
              <th style={{ border: "1px solid #ccc", padding: "10px" }}> Current MIM Balance </th>
              <th style={{ border: "1px solid #ccc", padding: "10px" }}>Currency</th>
              <th style={{ border: "1px solid #ccc", padding: "10px" }}>TotalAmount</th>
              <th style={{ border: "1px solid #ccc", padding: "10px" }}>Module Name</th>
              <th style={{ border: "1px solid #ccc", padding: "10px" }}>Payment Method</th>

            </tr>
        </thead>
        <tbody>
        {tableData.map((item:any, index) => (
              <tr key={index}>
                <td style={{ border: "1px solid #ccc", padding: "1px" }}>{index + 1}</td>
                <td style={{ border: "1px solid #ccc", padding: "10px" }}>{item.instrumentNo || "---"}</td>
                <td style={{ border: "1px solid #ccc", padding: "10px" }}>{item.ImpactorName || "---"}</td>

                <td style={{ border: "1px solid #ccc", padding: "10px" }}>{item.impactorEmail || "---"}</td>
                <td style={{ border: "1px solid #ccc", padding: "10px" }}>{
                  item.impactorJoinedDate
                    ? new Date(item.impactorJoinedDate).toLocaleDateString("en-GB")
                    : "---"
                }</td>
                <td style={{ border: "1px solid #ccc", padding: "10px" }}>{item.ImpactorContact || "---"}</td>
                <td style={{ border: "1px solid #ccc", padding: "10px" }}>{item.ImpactorCountry || "---"}</td>
                <td style={{ border: "1px solid #ccc", padding: "10px" }}>{
                  item.CurrentMIMBalance ? Math.round(item.CurrentMIMBalance) : "0"
                }</td>
                <td style={{ border: "1px solid #ccc", padding: "10px" }}>{item.currency || "---"}</td>
                <td style={{ border: "1px solid #ccc", padding: "10px" }}>{item.TotalAmount || "---"}</td>
                <td style={{ border: "1px solid #ccc", padding: "10px" }}>{item.moduleName || "---"}</td>
                <td style={{ border: "1px solid #ccc", padding: "10px" }}>{item.paymentMethod || "---"}</td>



              </tr>
            ))}
        </tbody>
      </table>
        )}
    </div>
      
        
   
    </div>
  );
};

export default MimBalance;